import { z } from 'zod'
import { Model } from './architecture'

export const SlugValidation = z.object({
  value: z.string({ required_error: '[Slug] value is required' }),
})

export class Slug extends Model {
  static create({ value }: z.infer<typeof SlugValidation>) {
    SlugValidation.parse({ value })
    return new Slug(value, false)
  }

  static empty() {
    return new Slug('', true)
  }

  constructor(
    private readonly _value: string,
    private readonly _empty: boolean
  ) {
    super()
  }

  get value() { return this._value.replaceAll(' ', '-').toLowerCase() } // prettier-ignore

  isEmpty() {
    return this._empty
  }

  toJSON() {
    return { value: this.value }
  }
}
